/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-12-07 14:13:53
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-05 15:28:46
 */
import { useEffect, useRef, useState } from "react";
import { ProFormSelect, ProFormText, ProTable } from "@ant-design/pro-components";
import dayjs from "dayjs";
import "./index.less";
import { fetchStartegyActionLog, fetchstrategyList } from "@/api/modules/strategy";
import { fetchADAccountList } from "@/api/modules/AdAccount";

import { useTranslation } from "react-i18next";
import { message, Select } from "antd";
import { useDebounce } from "@/utils/util";

const Log = () => {
	const { t } = useTranslation();
	const [advertise, setAdvertise] = useState([]);
	const [accountMap, setAccountMap] = useState(new Map());
	const [filterParams, setFilterParams] = useState({
		strategyName: "",
		advId: ""
	});

	const actionRef = useRef();
	useEffect(() => {
		const map = new Map();
		fetchADAccountList({
			pageSize: 999
		}).then(res => {
			if (res.code !== 200) {
				message.error(res.msg);
				return;
			}

			res.data.list.forEach(item => {
				map.set(item.advId, item.advName);
			});
			setAccountMap(map);
			setAdvertise(res.data.list);
		});
	}, []);

	const action = [
		{
			label: "ENABLE",
			value: "ENABLE"
		},
		{
			label: "DISABLE",
			value: "DISABLE"
		},
		{
			label: "custom_close_other_ads",
			value: "custom_close_other_ads"
		},
		{
			label: "budget:inc:$",
			value: "budget:inc:$"
		},
		{
			label: "budget:inc:%",
			value: "budget:inc:%"
		},
		{
			label: "budget:dec:$",
			value: "budget:dec:$"
		},
		{
			label: "budget:dec:%",
			value: "budget:dec:%"
		},
		{
			label: "budget:new:",
			value: "budget:new:"
		},
		{
			label: "conversion_bid:inc:$",
			value: "conversion_bid:inc:$"
		},
		{
			label: "conversion_bid:inc:%",
			value: "conversion_bid:inc:%"
		},
		{
			label: "conversion_bid:dec:$",
			value: "conversion_bid:dec:$"
		},
		{
			label: "conversion_bid:dec:%",
			value: "conversion_bid:dec:%"
		},
		{
			label: "conversion_bid:new:",
			value: "conversion_bid:new:"
		},
		{
			label: "bid:inc:$",
			value: "bid:inc:$"
		},
		{
			label: "bid:inc:%",
			value: "bid:inc:%"
		},
		{
			label: "bid:dec:$",
			value: "bid:dec:$"
		},
		{
			label: "bid:dec:%",
			value: "bid:dec:%"
		},
		{
			label: "bid:new:",
			value: "bid:new:"
		}
	];

	const scopeEnum = {
		ad: {
			text: "广告"
		},
		adgroup: {
			text: "广告组"
		},
		campaign: {
			text: "广告系列"
		}
	};

	const fetchData = async params => {
		console.log(filterParams);
		console.log("params", params);

		const res: any = await fetchStartegyActionLog({
			...params,
			...filterParams
		});
		return {
			success: true,
			data: res.data.list,
			total: res.data.total
		};
	};

	const searchValue = useDebounce(params => {
		let newParams = { ...params[0] };

		setFilterParams(newParams);

		if (actionRef?.current) {
			actionRef?.current?.reload();
		}
	}, 500);

	const columns: [] = [
		{
			title: t("automatedRules.actionHistory.table.column1"),
			dataIndex: "advId",
			width: "200",
			render: (_, record) => {
				return (
					<div>
						<span>{record?.advName}</span>
						<span>({record?.advId})</span>
					</div>
				);
			},

			valueEnum: () => {
				const advMap = {};
				advertise.forEach(item => {
					advMap[item.advId] = {
						text: item.advName
					};
				});

				return advMap;
			},
			fieldProps: {
				placeholder: t("automatedRules.actionHistory.table.column1.placeholder"),
				width: "100%",
				showSearch: true,
				onChange: advId => {
					searchValue({
						...filterParams,
						advId: advId
					});
				}
			},
			formItemProps: {
				label: false,

				width: "100%"
			},
			search: {
				label: false
			},
			sort: 2
		},
		{
			title: t("automatedRules.actionHistory.table.column2"),
			dataIndex: "strategyName",
			width: "30%",
			formItemProps: {
				label: false
			},
			fieldProps: {
				placeholder: t("automatedRules.actionHistory.table.column2.placeholder"),
				onChange: event => {
					console.log("13", {
						...filterParams,
						ruleName: event.target.value
					});

					searchValue({
						...filterParams,
						strategyName: event.target.value
					});
				}
			}
		},

		{
			title: t("automatedRules.actionHistory.table.column3"),
			dataIndex: "action",
			width: "20%",
			render: (_, record) => {
				if (record.actionValue) {
					return record.action.slice(0, record.action.length - 1) + record.actionValue + record.action.slice(-1);
				} else {
					return record.action;
				}
			},
			valueEnum: () => {
				const actionMap = {};
				action.forEach(item => {
					actionMap[item.value] = {
						text: item.label
					};
				});

				return actionMap;
			},
			fieldProps: {
				placeholder: t("automatedRules.actionHistory.table.column3.placeholder"),
				showSearch: true,
				onChange: action => {
					searchValue({
						...filterParams,
						action: action
					});
				}
			},
			formItemProps: {
				label: false
			}
		},
		{
			title: t("automatedRules.actionHistory.table.column4"),
			dataIndex: "scope",
			width: "120",
			valueEnum: scopeEnum,
			formItemProps: {
				label: false
			},
			fieldProps: {
				placeholder: t("automatedRules.actionHistory.table.column4.placeholder"),
				showSearch: true,
				onChange: scope => {
					searchValue({
						...filterParams,
						scope: scope
					});
				}
			}
		},
		{
			title: t("automatedRules.actionHistory.table.column5"),
			dataIndex: "scopeId",
			width: "200",
			formItemProps: {
				label: false
			},
			fieldProps: {
				placeholder: t("automatedRules.actionHistory.table.column5.placeholder"),
				showSearch: true,
				onChange: event => {
					searchValue({
						...filterParams,
						scopeId: event.target.value
					});
				}
			}
		},
		{
			title: t("automatedRules.actionHistory.table.column6"),
			dataIndex: "operateTime",
			render: (_, record) => {
				return dayjs(record.operateTime).format("YYYY-MM-DD HH:mm:ss");
			},
			valueType: "dateTime",
			width: "200",
			formItemProps: {
				label: false
			},
			fieldProps: {
				placeholder: t("automatedRules.actionHistory.table.column6.placeholder"),
				showSearch: true,
				onChange: startTime => {
					searchValue({
						...filterParams,
						startTime: startTime ? dayjs(startTime).format("YYYY-MM-DD HH:mm:ss") : ""
					});
				}
			}
		},
		{
			valueType: "dateTime",
			dataIndex: "endTime",
			hideInTable: true,
			fieldProps: {
				placeholder: t("automatedRules.actionHistory.table.column7.placeholder"),
				showSearch: true,
				onChange: endTime => {
					searchValue({
						...filterParams,
						endTime: endTime ? dayjs(endTime).format("YYYY-MM-DD HH:mm:ss") : ""
					});
				}
			}
		}
	];

	return (
		<div className="actionLogContainer">
			<div className="actionLogContent">
				<p className="actionLogTitle">{t("automatedRules.actionHistory.title")}</p>
				<ProTable
					columns={columns}
					options={false}
					search={{
						optionRender: (searchConfig, formProps, dom) => [dom[2]],
						defaultCollapsed: false
					}}
					actionRef={actionRef}
					rowKey={() => "operateTime" + Math.random()}
					request={fetchData}
				/>
			</div>
		</div>
	);
};

export default Log;
